import { useEffect, useState } from 'react'

import { where } from 'firebase/firestore'

import FirestoreService from '../services/firestoreService'

import { RiderTeamMemberModel } from '../models/rider-team-member/riderTeamMember.model'
import { RegistrationByDayModel } from '../models/registrations-by-day/registrationByDay.model'

import { IRegistrationByDayInterface } from '../models/registrations-by-day/registrationByDay.interface'
import { IRiderTeamMemberInterface } from '../models/rider-team-member/riderTeamMember.interface'

import { CONST } from '../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

export interface IEventTeamMemberInterface {
  [key: string]: {
    teamMember: IRiderTeamMemberInterface
    rider: IRegistrationByDayInterface | null
  }[]
}
export const useEventRiderTeamMembers = (eventId: string) => {
  const [eventTeamMembersLoading, setEventTeamMembersLoading] = useState(true)
  const [eventTeamMembers, setEventTeamMembers] = useState<IEventTeamMemberInterface>({})

  const getEventRiderTeamMembers = async () => {
    if (!eventId) return

    try {
      setEventTeamMembersLoading(true)

      const riderTeamMembers: IRiderTeamMemberInterface[] = []
      const registrationsByDay: IRegistrationByDayInterface[] = []

      const riderTeamMembersSnaps = await FirestoreService.filterItems(
        COLLECTIONS.RIDER_TEAM_MEMBER.NAME,
        [where(COLLECTIONS.RIDER_TEAM_MEMBER.FIELDS.EVENT_ID.KEY, '==', eventId)]
      )

      riderTeamMembersSnaps.forEach((current) => {
        riderTeamMembers.push(RiderTeamMemberModel.fromFirestoreDoc(current).toObject())
      })

      const registrationByDaySnaps = await FirestoreService.filterItems(
        COLLECTIONS.REGISTRATION_BY_DAY.NAME,
        [where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.EVENT_ID.KEY, '==', eventId)]
      )

      registrationByDaySnaps.forEach((current) => {
        registrationsByDay.push(RegistrationByDayModel.fromFirestoreDoc(current).toObject())
      })

      const eventTeamMembers_: IEventTeamMemberInterface = {}

      riderTeamMembers.forEach((riderTeamMember) => {
        const role = riderTeamMember.teamMemberRole

        if (role) {
          if (!eventTeamMembers_[role]) eventTeamMembers_[role] = []

          eventTeamMembers_[role].push({
            teamMember: riderTeamMember,
            rider:
              registrationsByDay.find(
                (registrationByDay) =>
                  registrationByDay.registrationDocId === riderTeamMember.registrationDocId &&
                  registrationByDay.riderId === riderTeamMember.riderId &&
                  registrationByDay.horsesSelected.some(
                    (horse) => horse.id === riderTeamMember.horseId
                  )
              ) || null,
          })
        }
      })

      setEventTeamMembers(eventTeamMembers_)
    } catch (error) {
      console.error(error, 'error')
    } finally {
      setEventTeamMembersLoading(false)
    }
  }

  useEffect(() => {
    getEventRiderTeamMembers().then()
  }, [eventId])

  return {
    eventTeamMembers,
    eventTeamMembersLoading,
    getEventRiderTeamMembers,
  }
}
